import { actions } from 'react-redux-form'
import services from 'services'
import tokenStore from 'services/token-store'
import mappers from 'admin/services/mappers'
import { addMessage } from 'actions'
import { logout } from 'actions/session'
import models from 'admin/models'
import { mapLanguageToComponentProps } from 'admin/i18n'
import { clearIntercomCookies, clearUserDataFromIntercom } from 'chat-bots/intercom'
import { httpError } from 'actions/http'
import { subscriptionNeeded } from 'admin/actions/billing'

export default {

  resetState() {
    const { dispatch } = services.store
    dispatch(logout())
    Object.keys(models).forEach((model) => {
      dispatch(actions.reset(model))
      dispatch(actions.setInitial(model))
    })
  },

  fetchFavoriteVideos(context) {
    const favoriteContext = !context ? 'user' : context
    return this.fetch(`/v1/admin/favorite-videos/${favoriteContext}`)
      .then(mappers.mapQuestionJsonToModel)
  },

  saveFavoriteVideo(payload, context) {
    const body = {
      video: mappers.mapQuestionModelToJson(payload.video),
      isNewVideo: payload.isNewVideo,
    }
    return this.fetch(`/v1/admin/favorite-videos/${context}`, { method: 'PUT', body })
      .then(mappers.mapQuestionJsonToModel)
  },

  deleteFavoriteVideo(videoId, context) {
    return this.fetch(`/v1/admin/favorite-videos/${context}/${videoId}`, { method: 'DELETE' })
  },

  updateVideo({
    title,
    tags,
    selectedLibrary,
    videoId,
  }) {
    return this.fetch('/v1/admin/videos/update', { method: 'POST', body: {
      title,
      tags,
      selectedLibrary,
      videoId,
    } })
  },

  fetchCompany() {
    return this.fetch('/v1/admin/company')
      .then(mappers.mapCompanyJsonToModel)
  },

  saveCompany(company) {
    const body = mappers.mapCompanyModelToJson(company)
    return this.fetch('/v1/admin/company', { method: 'PUT', body })
      .then(mappers.mapCompanyJsonToModel)
  },

  fetchJobAdApplications(jobAdId) {
    return this.fetch(`/v1/admin/job-ads/${jobAdId}/applications`)
      .then(mappers.mapApplicationJsonToModel)
  },

  changeJobAdStatus(jobAdId, status) {
    return this.fetch(`/v1/admin/job-ads/${jobAdId}/status`, { method: 'PUT', body: { status } })
  },

  changeInterviewStatus(id, status) {
    return this.fetch(`/v1/admin/interviews/${id}/status`, { method: 'PUT', body: { status } })
  },

  changeInterviewRoundStatus(interviewRoundId, status) {
    return this.fetch(`/v1/admin/interview-rounds/${interviewRoundId}/status`, { method: 'PUT', body: { status } })
  },

  createInterview(interviewType, jobAdId) {
    const url = '/v1/admin/interviews'
    const body = { interviewType, jobAdId }
    return this.fetch(url, { method: 'POST', body })
      .then(mappers.mapInterviewJsonToModel)
  },

  saveInterview(interview) {
    const body = mappers.mapInterviewModelToJson(interview)
    return this.fetch(`/v1/admin/interviews/${interview.id}`, { method: 'PUT', body })
      .then(mappers.mapInterviewJsonToModel)
  },

  deleteInterview(interviewId) {
    return this.fetch(`/v1/admin/interviews/${interviewId}`, { method: 'DELETE' })
  },

  search(query, filter) {
    return this.fetch('/v1/admin/search', { method: 'POST', body: { query, filter } })
      .then(({ applications, candidates }) => ({
        applications: {
          ...applications,
          data: mappers.mapApplicationJsonToModel(applications.data),
        },
        candidates: {
          ...candidates,
          data: mappers.mapCandidateJsonToModel(candidates.data),
        },
      }))
  },

  fetch(url, params) {
    return services.fetch(url, params)
      .catch((error) => {
        const { dispatch, getState } = services.store
        const { i18n } = mapLanguageToComponentProps()(getState())
        const { messages, language } = getState().global
        const responseStatus = error.response ? error.response.status : null

        if ('response' in error && error.response.status === 401) {
          tokenStore.removeToken()
          clearUserDataFromIntercom(language)
          clearIntercomCookies(true)
          this.resetState()
          dispatch(httpError(401))
          const sessionExpiredMessages = messages.filter(m => m.text === i18n.session.expired)
          if (sessionExpiredMessages.length < 1) {
            dispatch(addMessage({ style: 'danger', text: i18n.session.expired }))
          }

          if (window.location.pathname.startsWith('/admin/frames/recording/')) {
            sessionStorage.removeItem('persist:root')
            window.location.replace('/admin/frames/403')
          }
        } else {
          if (getState().global.httpError !== responseStatus) {
            dispatch(httpError(responseStatus))
          }
          if ('response' in error && error.response.status === 402) {
            dispatch(subscriptionNeeded(true))
          }
        }
        throw error
      })
  },

}
